import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useFullScreenHandle } from "react-full-screen";
import { Container } from "react-bootstrap";
import { RotatableBuilding } from "../../components/RotatableBuilding/RotatableBuilding";
import Sidebar from "../../components/Sidebar/Sidebar";
import { ReactComponent as HorizontalDevice } from "../../assets/icons/horizontalDevice.svg";
import "./MobileLayout.scss";
import { AppContext } from "../../context";

const infoArrayIds = [1, 2, 3, 4, 5, 6, 7, 8];
const infoArrayIds2 = [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41];

export const MobileLayout = ({ setAppState, loading, setHoveredArea, hoveredArea }) => {
  const { floorImages } = useSelector((state) => state.floor);
  const [currentWidth, setCurrentWidth] = useState(0);
  const [currentHeight, setCurrentHeight] = useState(0);
  const handleFullScreen = useFullScreenHandle();
  const state = useContext(AppContext);

  const {
    imgMapprRef
  } = state;

  const isLandscape = () => window.matchMedia("(orientation:landscape)").matches,
    [orientation, setOrientation] = useState(isLandscape()),
    onWindowResize = () => {
      clearTimeout(window.resizeLag);
      window.resizeLag = setTimeout(() => {
        delete window.resizeLag;
        setOrientation(isLandscape());
      }, 200);
    };

  useEffect(() => (
    onWindowResize(),
      window.addEventListener("resize", onWindowResize),
      () => window.removeEventListener("resize", onWindowResize)
  ), [onWindowResize]);

  useEffect(() => {
    setCurrentHeight(window.innerHeight);
    setCurrentWidth(window.innerWidth);
  }, [orientation]);

  const handleClearSelectedAreas = () => {
    imgMapprRef.current.clearHighlightedArea();
  };



  return (
    <Container fluid className="main-wrapper fullscreen" id={"main-wrapper"}>
      {((!orientation && (navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/iPhone/i))) || (navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/iPhone/i))) &&
        <div className={"deviceHorizontally"} style={{ height: "100vh" }}>
          <img className={"logo"} src="/logo.png" alt="" />
          <p className="rotate-text mt-5 mb-4">
            Please rotate device horizontally’
          </p>
          <HorizontalDevice />
        </div>
      }
      {loading && (
        <div className={`loading-container ${(navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/iPhone/i)) && "loading-container-mobile"}`}>
          <div>
            <div className="loading" />
            <div id="loading-text">loading</div>
          </div>
          <div className="text-allow">Please allow a few moments for the app to load</div>
        </div>
      )}
      <>

        {floorImages.length > 0 && (
          <RotatableBuilding
            activeBuilding={1}
            floorImages={floorImages}
            setAppState={setAppState}
            handleFullScreen={handleFullScreen}
            currentWidth={currentWidth}
            setCurrentWidth={setCurrentWidth}
            currentHeight={currentHeight}
            setCurrentHeight={setCurrentHeight}
            setHoveredArea={setHoveredArea}
            hoveredArea={hoveredArea}
            infoArrayIds={infoArrayIds}
            mode={true}
            infoArrayIds2={infoArrayIds2}
          />
        )}
        <Sidebar
          setAppState={setAppState}
          hoveredArea={hoveredArea}
          isInfoDataExist={(infoArrayIds.includes(parseInt(hoveredArea?.name.id)) || infoArrayIds2.includes(parseInt(hoveredArea?.name.id)))}
          handleClearSelectedAreas={handleClearSelectedAreas}
        />
      </>
    </Container>
  );
};
